/**
 * AI document glyph from the design system, shown while a statement is being read.
 *
 * Deliberately multi-color, so the fills stay fixed rather than following `currentColor`.
 */
function AiDocument(props) {
  return (
    <svg
      aria-hidden='true'
      viewBox='0 0 30 30'
      width='30'
      height='30'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      {/* evenodd is inherited by the arrow path, which needs it for its cutout; the other two
          shapes override it, as in the source asset. */}
      <g fillRule='evenodd'>
        <path
          fill='#02769D'
          fillRule='nonzero'
          d='M20.817 1c.65 0 1.275.261 1.735.722l4.295 4.294c.46.456.721 1.085.721 1.735V24.75c0 1.356-1.1 2.456-2.456 2.456h-7.475a8.542 8.542 0 0 0 2.14-2.457h5.335V10.01h-5.324c-.68 0-1.228-.548-1.228-1.229V3.457h-8.19v8.79a8.452 8.452 0 0 0-2.458 1.041l.002-9.831C7.914 2.1 9.014 1 10.37 1h10.446Zm.2 2.656v3.896h3.895l-3.895-3.896Z'
        />
        <path
          fill='#038AB7'
          d='M12.5 13a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm.47 3.118a.6.6 0 0 0-.94 0l-1.674 2.109a.6.6 0 0 0 .47.973h1.032a.6.6 0 0 0-.031.192v5.331a.6.6 0 0 0 .6.6h.146a.6.6 0 0 0 .6-.6v-5.331a.6.6 0 0 0-.031-.192h1.032a.6.6 0 0 0 .47-.973Z'
        />
        <path
          fill='#F2BD66'
          fillRule='nonzero'
          d='M18.125 20c-.09-3.59-1.535-4.934-5.125-4.764 3.59-.17 4.965-1.646 4.875-5.236.09 3.59 1.535 4.934 5.125 4.764-3.59.17-4.965 1.646-4.875 5.236ZM7.125 29C7.035 25.41 5.59 24.066 2 24.236c3.59-.17 4.965-1.646 4.875-5.236.09 3.59 1.535 4.934 5.125 4.764-3.59.17-4.965 1.646-4.875 5.236Z'
        />
      </g>
    </svg>
  )
}

export default AiDocument
